module.exports = __webpack_public_path__ + "img/ndalegal-logo.297f04bc.svg";